import  verificationComponent  from './verification';
import  passwordRecoveryComponent  from './passwordRecovery';
import  fileUploadComponent  from './fileUpload';
import  buttonHandler  from './buttonHandler';

export default function (Alpine) {
    if (typeof window.verificationComponent !== 'function') {
        window.verificationComponent = verificationComponent;
    }

    if (typeof window.passwordRecoveryComponent !== 'function') {
        window.passwordRecoveryComponent = passwordRecoveryComponent;
    }

    if (typeof window.fileUploadComponent !== 'function') {
        window.fileUploadComponent = fileUploadComponent;
    }

    Alpine.data('verificationComponent', verificationComponent);
    Alpine.data('passwordRecoveryComponent', passwordRecoveryComponent);
    Alpine.data('fileUploadComponent', fileUploadComponent);
    Alpine.data('buttonHandler', buttonHandler);
}
